var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"nameCircle text-lightBlue",style:({width: _vm.width,height: _vm.height,lineHeight: _vm.lineHeight})},[_vm._v(_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }